import { ICountry } from "src/app/models/parameters/ICountry";
import { Observable } from "rxjs";

export abstract class ICountryService {
  abstract getCountries(): Observable<ICountry[]>;
  abstract getCountriesDropdownWithLegalFormsByProject(projectId: string): Observable<any>;
  abstract getProjectCountries(projectId: string): Observable<any[]>;
  abstract getAllNationalities(): Observable<any>;
  abstract getCountriesDropdown(): Observable<any>;
  abstract getCountriesDropdownWithLegalForms(): Observable<any>;
}
